import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../../assets/styles/Layout.css';

const Layout = ({ layoutType, user }) => {
  return (
    <div className={`layout ${layoutType}`}>
      <Header user={user} />
      <div className="page-content">
        <Outlet />
      </div>
      {layoutType === 'public' && <Footer />}
    </div>
  );
};

export default Layout;